<div class="page-content">
    <div class="page-header">
        <h1>Projects</h1>
        <div class="page-description">Mes projets</div>
    </div>

    <div class="page-body">
        <div class="cards-container">
            <div class="row g-2">
                    <div class="col-sm-12 col-lg-3">
                        <kpi-card
                            title="Nombre total de projets"
                            descriptionContent="Nombre total de projets qui me sont accessibles"
                            [body]="{value: totalCount}"
                            [footer]="{prefix: 'Dont ', value: projectsDataSource.data.length, suffix: ' chargés'}"
                            [isLoading]="totalCount === 0"
                            class="h-100">
                        </kpi-card>
                    </div>
                    <div class="col-sm-12 col-lg-3">
                        <ed-button
                            (click)="openModalCreate()"
                            [colorSchema]="ButtonColors.Primary"
                            class="h-100"> Ajouter un nouveau projet
                        </ed-button>
                        <ed-button
                            (click)="exportAll()"
                            [colorSchema]="ButtonColors.Secondary"
                            class="h-100"> Exporter tous les projets
                        </ed-button>
                    </div>
            </div>

            <br/>
            <div class="row g-3">
                             
                <div class="col-sm-12 col-md-8">
                    <label>Recherche globale</label>
                    <ed-textfield
                        placeholder="Rechercher par code ou label"
                        [ngModel]="q"
                        (ngModelChange)="updateQuerySearch($event)"
                        [icon]="'icon-search-lg'">
                    </ed-textfield>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-4 ">
                    <label>Statut</label>
                    <ed-search
                        placeholder="filter par statut"
                        [options]="statusList"
                        [isMulti]="true"
                        [ngModel]="statusFilters"
                        (ngModelChange)="updateStatusFilters($event)">
                    </ed-search>   
                </div>
                <div class="co-sm-12 col-md-4">
                    <label>Activité</label>
                    <ed-search
                        placeholder="filter par activités"
                        [options]="activityList"
                        [isMulti]="true"
                        [ngModel]="activityFilters"
                        (ngModelChange)="updateActivityFilters($event)">
                    </ed-search>   
                </div>
                <div class="co-sm-12 col-md-4">
                    <label>Chef.fe de projets</label>
                    <ed-search
                        placeholder="filter par chef.fe de projets"
                        [options]="leadUserList"
                        [isMulti]="true"
                        [ngModel]="leadUsersFilters"
                        (ngModelChange)="updateLeadUsersFilters($event)">
                    </ed-search>   
                </div>
            </div>
            <br/>
            <br/>
            <div class="row g-3">
                <div class="col-sm-12">
                    <div style="background-color: white;">
                        <ed-table 
                            [isLoading]="isLoading" 
                            [dataSource]="projectsDataSource" 
                            [displayedColumns]="projectsColumns"
                            (onDropdownMenuClick)="onDropdownMenuClick($event.object, $event.event)"
                            (onRowClick)="goToDetail($event)"
                            [sortInfo]="{field: sort.key, order: sort.direction}"
                            [areActionsInElements]="true"
                            (onSortChanged)="onSortChanged($event)"
                            EdInfiniteScroll
                            [listenToScroll]="totalCount > projectsDataSource.data.length"
                            (nearEnd)="displayMoreProjects()">
                    </ed-table>
                    @if(totalCount > projectsDataSource.data.length && isLoading){
                    <br/>
                    <ed-skeleton-list
                        [numberOfRows]="1"
                        [numberOfBlocs]="projectsColumns.length"
                        ></ed-skeleton-list>
                    }
                     <br/>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
<ed-alert></ed-alert>
</div>